export default __webpack_public_path__ + "static/media/17.2b346d3e.png";